import { render, staticRenderFns } from "./IzinPNBPChart.vue?vue&type=template&id=19a2d50e&"
import script from "./IzinPNBPChart.vue?vue&type=script&lang=js&"
export * from "./IzinPNBPChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports